import { Button as ReakitButton } from 'reakit/Button'
import styled from 'styled-components'

import { colors } from '~/styles/colors'
import { fonts } from '~/styles/fonts'

export const ButtonLink = styled(ReakitButton)({
  fontSize: '0.875rem',
  lineHeight: 1.25,
  fontWeight: fonts.text.medium,
  color: colors.dark,
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  textAlign: 'left',

  svg: {
    flexShrink: 0
  }
})
